module.exports = __webpack_public_path__ + "img/correct.e830aea4.svg";